<script lang="ts">
	import type { BlogListItem } from "../templates/BlogProps.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { toDateLongMonthYearFormat } from "../../../core/utils/toDateLongMonthYearFormat.js";
	import logo from "../../../core/assets/logo-blue.svg";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import DynamicPicture from "./Picture/DynamicPicture.svelte";
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import Icon from "./Icon.svelte";
	import BlogCategoryBadge from "./BlogCategoryBadge.svelte";
	import ReadingTime from "./ReadingTime.svelte";
	import translations from "./BlogFeaturedCard.translations.json";
	import { getTranslate } from "../utils/getTranslate.js";
	import { getTenant } from "../getTenant.js";

	export let item: BlogListItem;

	const tenant = getTenant();
	const translate = getTranslate(translations);
</script>

<div
	class="border-lttertiary hover:border-ltprimary-300 group flex flex-col border bg-white transition-colors duration-300 xl:h-[32.5rem] xl:flex-row"
>
	<a
		href={item.href}
		class="border-lttertiary relative block min-h-64 w-full shrink-0 overflow-hidden xl:min-h-0 xl:w-[45%] xl:border-r"
	>
		{#if item.primaryImage}
			<DynamicPicture
				loading="eager"
				class="size-full object-cover object-center"
				imgClass="size-full object-cover object-center transition-transform duration-500 ease-out group-hover:scale-105"
				alt={item.title}
				image={item.primaryImage}
				width={0}
				height={0}
				bucket="storage"
				sourcesets={{
					"<md": [720, 0],
					">md": [760, 0],
					">lg": [900, 0],
					">xl": [754, 520],
				}}
			/>
		{:else}
			<div class="bg-lttertiary-50 flex size-full items-center justify-center">
				<StaticPicture alt="" image={logo} width={250} height={38} class="w-40" imgClass="h-auto w-full" />
			</div>
		{/if}
		<div class="absolute left-5 top-5">
			<BlogCategoryBadge category={item.category} />
		</div>
	</a>
	<div class="flex flex-1 flex-col justify-center gap-6 p-8 xl:p-12">
		<div class="text-2xs text-ltmeta flex items-center gap-3.5 uppercase tracking-wider">
			<span>{toDateLongMonthYearFormat(item.publishedAt, tenant.locale)}</span>
			<span class="bg-lttertiary size-1 rounded-full"></span>
			<span><ReadingTime minutes={item.readingMinutes} /></span>
		</div>
		<div
			class="text-ltprimary font-bahnschrift text-2lg/[1.08] line-clamp-2 max-w-[22rem] uppercase tracking-[0.01em] group-hover:underline xl:text-[2.375rem]"
		>
			<a href={item.href}>{nbspify(item.title)}</a>
		</div>
		<div class="text-ltsecondary line-clamp-3 max-w-[30rem] text-base/[1.6]">
			{nbspify(item.perex)}
		</div>
		<a
			href={item.href}
			class="text-ltprimary-300 hover:text-ltprimary-100 font-roboto flex w-fit items-center gap-2.5 text-xs/[1.375rem] font-bold uppercase tracking-[0.06em] transition-colors duration-300"
			aria-label={translate("readAria", { title: item.title }, true)}
		>
			{translate("readArticle")}
			<span
				class="flex size-6 shrink-0 items-center justify-center rounded-full border border-current transition-transform duration-300 group-hover:translate-x-1"
			>
				<Icon class="h-3 w-[0.4375rem]" icon={arrowRight} />
			</span>
		</a>
	</div>
</div>
